<template>
  <div class="c-footer c-footer-3">
    <div class="footer-content clear content-3">
      <div class="f-3-left record3 recordt">
        <div>
          <!-- <p class="l-word" id="show_logo"><img src="" alt="" width="150px" height="50px"></p> -->
          <p class="l-word" id="show_logo">
            <img src="@/assets/images/iedu/logo.png" alt width="80px" />
          </p>
          <p class="slogan slogan-des">金牌课程规划师+AI自适应推荐</p>
          <p class="slogan">基于全网教育大数据，好课超严选，成绩大进步</p>
          <!-- <p id="companyAddressNode" class="record3-top">北京市石景山区金融街长安中心1号楼12层</p> -->
          <!-- <p id="copyrightList" mark="middle" class="record3-top">安博教育　技术支持<a class="footer_beian" href="http://www.beian.miit.gov.cn/" target="_blank" style="display: none;">京ICP备15011506号</a></p> -->
        </div>
      </div>
      <div class="f-3-middle recordt">
        <!-- <div id="foot_showContents"><a href="#/about?type=1" target="_blank">关于我们</a><a href="#/about?type=2" target="_blank">大事记</a><a href="#/about?type=3" target="_blank">联系我们</a><a href="#/about?type=4" target="_blank">就业平台</a></div> -->
      </div>
      <div class="f-3-right recordt">
        <div class="clear">
          <div>
            <p style="font-size: 16px;margin-top: 40px;color: #999;">商务合作：admin@iwords.top</p>
            <p style="font-size: 16px;margin-top: 20px;color: #999;">© 煎蛋选课吉ICP备19007319号</p>
            <p
              style="margin-top: -10px;position: relative;margin-left: -5px;"
              class="img-hover qimg_hover"
            >
              <!-- <span id="txUrl" class="weixin-logo">
                <img :src="imgPath.pay_wx" alt />
              </span> -->
              <!--                         <em class="pop-ewm pop-ewm1 wxPic" id="show_wxPic" style="display: ;"></em> -->
            </p>
          </div>
          <!-- <div class="erwm wxPic" id="show_wxPic" ><img :src="imgPath.yunzhi_code" alt="" width="85" height="85"><span class="opcMask"></span></div> -->
          <div class="erwm wxPic" id="show_wxPic">
            <!-- <img src="@/assets/images/iedu/qrcode_1.jpg" alt width="85" height="85" />
            <span class="opcMask"></span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgPath from "@/common/img-path";
export default {
  name: "BodyFooter",
  data() {
    return {
      imgPath: imgPath
    };
  }
};
</script>

<style scoped>
.c-footer {
  width: 100%;
  /*background-color: #32333a;*/
  /*border: 1px solid #353535;*/
}
.footer-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  color: #a1a4b3;
}
.c-footer.c-footer-1 {
  min-height: 205px;
  background: #32333a;
  overflow: hidden;
}
.content-1 {
  min-height: 205px;
}
.c-footer.c-footer-2 {
  height: 92px;
  background: #2e2e2e;
}
.content-2 {
  height: 92px;
}
.c-footer.c-footer-3 {
  min-height: 178px;
  background: #24252a;
}
.content-3 {
  min-height: 168px;
}
.c-footer.c-footer-4 {
  height: 50px;
  background: #000;
}
.content-4 {
  height: 50px;
}
.footer-content > div {
  margin: 10px 0 0;
  float: left;
  display: inline-block;
  vertical-align: middle;
}
.f-3-left {
  width: 48%;
  min-height: 148px;
}
.f-3-left > div {
  width: 410px;
  margin: 0 auto;
}

.f-3-middle {
  width: 22%;
  height: 148px;
}
.f-3-middle > div {
  width: 180px;
  margin: 0 auto;
  border-right: 1px solid #46474c;
  border-left: 1px solid #46474c;
  padding-left: 20px;
  padding-right: 0px;
}
.f-3-middle > div a {
  display: inline-block;
  width: 80px;
  margin: 3px;
  color: #a1a4b3;
  text-align: left;
  line-height: 30px;
}
.f-3-right {
  width: 29%;
  height: 148px;
}
.f-3-right > div {
  width: 246px;
  margin-left: 15%;
}
.f-3-right > div div p span {
  font-size: 36px;
  cursor: pointer;
}
.f-3-right > div div {
  float: left;
}
.f-3-right > div div p span:last-child {
  /*position: relative;*/
  /*top: -4px;*/
}
.erwm {
  width: 65px;
  height: 65px;
  margin: 30px 0 0 20px;
}
.f-1-left {
  float: left;
  width: 60%;
}
.f-1-right {
  float: left;
  width: 40%;
}
.footer-top-box {
  padding: 1%;
  width: 98%;
}
.f-1-left > div {
  float: left;
  width: 19%;
  border-right: 1px solid #404046;
  height: 164px;
}
.f-1-left > div p {
  color: #ededed;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  margin-bottom: 5px;
}
.f-1-left > div a {
  display: block;
  width: 100%;
  color: #7e7f81;
  text-align: center;
  line-height: 25px;
  font-size: 12px;
}
.f-1-right > p {
  text-align: left;
  font-size: 12px;
  color: #7e7f81;
  padding: 0 40px;
}
.f-1-right > p.l-word {
  font-size: 34px;
  color: #fff;
}
.f-1-right > p:first-child {
  margin-bottom: 10px;
}
.f-1-right > p:first-child span {
  display: inline-block;
  width: 150px;
  height: 50px;
  font-size: 18px;
}
.f-1-right > p span {
  /*font-size: 32px;*/
  /*margin: 0 5px;*/
}
.f-1-right > p img {
  cursor: pointer;
  margin-right: 15px;
}
.footer-content > .f-1-bottom {
  width: 100%;
  margin: 0;
  line-height: 30px;
  text-align: center;
  color: #a1a4b3;
  font-size: 12px;
}

.c-footer-2 .content-2 > div {
  width: 100%;
  text-align: center;
  padding-top: 15px;
  color: #747474;
  font-size: 12px;
}
.c-footer-2 .content-2 > div a {
  color: #ededed;
  font-size: 14px;
  margin: 0 8px;
}
.c-footer-2 .content-2 span {
  display: block;
  width: 100%;
  line-height: 30px;
  font-size: 12px;
  color: #949494;
  text-align: center;
}
.f-1-bottom span {
  color: #d77d10;
}

.footer-content > .f-4-left {
  float: left;
  width: 52%;
  line-height: 50px;
  margin: 0;
  text-align: center;
  color: #949494;
  font-size: 12px;
}
.footer-content > .f-4-right {
  float: left;
  width: 48%;
  line-height: 50px;
  margin: 0;
  text-align: center;
  color: #747474;
}
.footer-content > .f-4-right a {
  color: #fff;
  margin: 0 12px;
  font-size: 14px;
}

.f-3-right > div div p span a {
  display: inline-block;
  font-size: 36px;
}

.pop-ewm {
  position: absolute;
  bottom: 48px;
  right: 45%;
  display: none;
}
.pop-ewm.pop-ewm1 {
  right: 60%;
}

/*��������*/

.record {
  margin-top: 10px;
}

#footerContents .picture {
  width: 14px;
  height: 16px;
  /* background: url('../images/por_1.png') no-repeat center; */
  margin-left: 2px;
}

.record .stan {
  line-height: 16px;
  /*color: #7e7f81;*/
  /*padding-left: 8px;*/
}

.record2 .picture2 {
  display: inline-block;
  width: 14px;
  height: 16px;
  /* background: url('../images/por_1.png') no-repeat center; */
  position: relative;
  top: 2px;
  margin-left: 20px;
}

.record2 .rech {
  display: inline-block;
  font-size: 12px;
}

.f-3-left > div > .record3-top {
  font-size: 12px;
  color: #a1a4b3;
  margin: 0px;
}

.content-3 .record3 > div > .record3-bot {
  margin-top: 4px;
}

.record .stan3 {
  color: #a1a4b3;
}

.pageafter-box .c-footer.c-record4-4 {
  height: auto;
}

.footer-content > div.record-4-left {
  padding: 15px 0 15px 40px;
  text-align: left;
  line-height: 18px;
}

.record4-word {
  display: block;
}

.c-footer .record4 {
  height: auto;
  position: relative;
}

.record4-copy {
  font-size: 12px;
  padding-bottom: 3px;
  /* position: relative;
    bottom: 19px;
    padding-left: 45px;*/
}

.record4-copy .stan4 {
  color: #949494;
}

.record4 > div.record4-right {
  line-height: 1;
  position: absolute;
  top: 50%;
  margin-top: -7px;
}

.record .stan {
  color: #a1a4b3;
}

.record .stan3 {
  color: #e0e0e0;
}

.record4-copy .stan4 {
  color: #949494;
}
.footer-content .record2 .stan2 {
  font-size: 12px;
}
#footerContents .c-record4-4 {
  height: auto;
}
.record .stan:hover {
  text-decoration: underline;
}

.record .stan3:hover {
  text-decoration: underline;
}

.record4-copy .stan4:hover {
  text-decoration: underline;
}

.record2 .stan2:hover {
  text-decoration: underline;
}
.footer-content > .recordt {
  margin-top: 20px;
}
.footer-content > .f-4-left .footer_beian {
  color: #949494;
}
#copyrightList .footer_beian {
  color: #949494;
}
#footerContents .stan2 {
  color: #949494;
}

.c-footer p.qimg_hover span i {
  display: inline-block;
  width: 36px;
  height: 36px;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.weixin-logo img {
  width: 40px;
  margin-top: 20px;
}
.slogan {
  font-size: 16px;

  color: #a1a4b3;
}
.slogan-des {
  margin-top: 10px;
}
</style>
